import Vue from "vue"
import Vuex from "vuex"
import LogLevel from "@/model/log/LogLevel"
import ApplicationStore from "@/store/modules/ApplicationStore"
import AccountStore from "@/store/modules/AccountStore"
import FieldStore from "@/store/modules/FieldStore"
import SessionStore from "@/store/modules/SessionStore"
import ProviderStore from "@/store/modules/ProviderStore"
import TestCaseStore from "@/store/modules/TestCaseStore"
import ValidationStore from "@/store/modules/ValidationStore"
import LearnHowStore from "@/store/modules/LearnHowStore"
import ProveStore from "@/store/modules/ProveStore"

Vue.use(Vuex)

const STORAGE_KEY = "store"
const storageEnabled = process.env.VUE_APP_LOAD_STORE_FROM_STORAGE === "true"
let initialStateJson = "{}"

const store = new Vuex.Store({
    modules: {
        application: ApplicationStore,
        account: AccountStore,
        field: FieldStore,
        provider: ProviderStore,
        learnHow: LearnHowStore,
        session: SessionStore,
        testCase: TestCaseStore,
        validation: ValidationStore,
        prove: ProveStore,
    },

    state: {
        logLevel: LogLevel.INFO,
    },
    getters: {
        applicantInfo(state) {
            // TODO: do we set this in the case of separate patient or co-app
            const primaryApp = state.application.data?.primary
            return {
                firstName: primaryApp?.firstName,
                lastName: primaryApp?.lastName,
                id: state.application.data.externalCustomerId,
            }
        },
    },

    mutations: {
        clearStorage() {
            if (storageEnabled) {
                sessionStorage.removeItem(STORAGE_KEY)
            }

            try {
                this.replaceState(JSON.parse(initialStateJson))
            } catch (e) {
                console.error("Error restoring to initial state", e)
            }
        },

        initializeStore(state) {
            initialStateJson = JSON.stringify(state)

            if (storageEnabled) {
                const savedStateJson = sessionStorage.getItem(STORAGE_KEY)

                if (savedStateJson) {
                    this.replaceState(Object.assign(state, JSON.parse(savedStateJson)))
                }
            }
        },
    },
    actions: {},
})

store.subscribe((mutation, state) => {
    if (storageEnabled) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store.state))
    }
})

export default store
